import { render } from "./AudienceWizard.vue?vue&type=template&id=51317740"
import script from "./AudienceWizard.vue?vue&type=script&lang=js"
export * from "./AudienceWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__